import type { HubConnection } from '@microsoft/signalr';

export enum PROSJEKT_TYPE {
    LTT = 1,
    KOM = 2,
    TEK = 3,
    TILTAK = 4,
}

export enum REGISTRERING_STATUS {
    NY,
    FULLFORT,
    AVVIST,
}

export type FORM_REGION =
    | 'Oslo'
    | 'Trondheim'
    | 'Sverige'
    | 'Danmark'
    | 'Europa';

export const ValidFormRegions = [
    'Oslo',
    'Trondheim',
    'Sverige',
    'Danmark',
    'Europa',
] as const;

export enum ProsjektBrukerRolle {
    Administrerendedirektor = 'Administrerendedirektor',
    Forvaltningsdirektor = 'Forvaltningsdirektor',
    Okonomisjef = 'Okonomisjef',
    Prosjektdirektor = 'Prosjektdirektor',
    Prosjekteier = 'Prosjekteier',
    Prosjektkontroller = 'Prosjektkontroller',
    Prosjektleder = 'Prosjektleder',
    Utviklingsdirektor = 'Utviklingsdirektor',
    Okonomi = 'Okonomi',
    Regiondirektor = 'Regiondirektor',
    Eiendomssjef = 'Eiendomssjef',
    Teknisksjef = 'Teknisksjef',
}

export enum LeverandorBrukerRolle {
    Bestiller = 'Bestiller',
    Avdelingsleder = 'Avdelingsleder',
    Okonomi = 'Okonomi',
    Ledergruppedirektor = 'Ledergruppedirektor',
}

export type ProsjektSteg = {
    type: PROSJEKT_TYPE;
    steg: number;
    navn?: string;
};

export type Aktivitet = {
    id: string | null;
    taskDefinitionId: string;
    navn: string;
    kandidatGruppe: string;
    kandidatGruppeEier: ProsjektBrukerRolle;

    tildeltTil: string | null;
    nesteAktivitet: string | null;
    startDato: string | null;
    utfortDato: string | null;
    formFields: Array<FormField>;
    skalHoppeOver: boolean;
    erGodkjenningOppgave: boolean;
    visibleExpression?: string;
};

export type FormField = {
    id: string;
    value?: string;
    defaultValue?: string;
    label?: string;
    type?: string;
    properties?: Array<FormFieldProperty>;
    validation: Array<FormFieldConstraint>;
};

export type FormFieldProperty = {
    id?: string;
    value?: string;
};

export type FormFieldConstraint = {
    name?: string;
    config?: string;
};

// ask backend to format request. - from Pascal case to camel case (as here)
export type UtforOppgave = {
    oppgaveId: string;
    registreringStatus?: string; //enum
    formFields?: Array<FormField>;
    autoAssign?: boolean;
};

// variables.ts
// Camunda default supported form field.
export enum VariableFieldType {
    String = 'String',
    Long = 'Long',
    Date = 'Date',
    Boolean = 'Boolean',
    Enum = 'Enum',
}
export interface ISignalRContext {
    connection: HubConnection | null;
    connected: boolean;
    startConnection: () => Promise<void>;
    stopConnection: () => Promise<void>;
}
